<template>
  <div class="global_top_nav"
       v-if="!isInit">
    <div v-html="img_logo_pc"></div>
    <header-login v-if="isShowLogin"></header-login>
    <!-- 搜索 -->
    <div class="global_top_nav_three">
      <div class="wrap">
        <div v-html="img_search_bg"></div>
        <form :action="$getOldWebUrl()+'/tourism/tourism_product.jsp'"
              method="post">
          <input :value="search_param.id1_order_by1"
                 id="id1_order_by1"
                 name="order_by1"
                 type="hidden">
          <input :value="search_param.id1_order_by2"
                 id="id1_order_by2"
                 name="order_by2"
                 type="hidden">
          <input name="init"
                 type="hidden"
                 value="1">
          <input name="search_visa"
                 type="hidden"
                 value="1">
          <div class="global_top_nav_three_search">
            <div @mouseenter="timeEnter"
                 @mouseleave="timeLeave"
                 class="time">
              <span>{{departure}}</span>
              <dl class="time_inner time_order_by"
                  v-show="time">
                <dd @click="orderBy('最近的出发时间')">最近的出发时间</dd>
                <dd @click="orderBy('最远的出发时间')">最远的出发时间</dd>
              </dl>
            </div>
            <div @mouseenter="daySenter"
                 @mouseleave="daysLeave"
                 class="time">
              <span>{{trip}}</span>
              <dl class="time_inner day_order_by"
                  ref="days"
                  v-show="days">
                <dd @click="orderBy('最少行程的天数')">最少行程的天数</dd>
                <dd @click="orderBy('最多行程的天数')">最多行程的天数</dd>
              </dl>
            </div>
            <input class="search_text"
                   id="route_name"
                   name="route_name"
                   placeholder="请输入景点、城市、目的地"
                   type="text"
                   v-model="search_param.route_name">
            <input @click="searchSubmit()"
                   class="search_btn"
                   id="ordinary_search"
                   name="search"
                   ref="ordinary_search"
                   type="submit"
                   value="搜索">
            <div class="clear"></div>
          </div>
        </form>
        <div class="global_top_nav_three_key">
          <div v-if="labels != null && labels.length !==0">
            <span :key="index"
                  v-for="(labelStr,index) in labels">
              <!-- 判断labelsstr是否为空 -->
              <span v-if="labelStr !==''">
                <a :href="$getOldWebUrl() + '/tourism/tourism_product.jsp?init=1&ordinary_search=1&search_visa=1&route_name='+labelStr">{{labelStr}}</a>
              </span>
            </span>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!-- 搜索结束 -->
    <!-- 导航 -->
    <div class="global_top_nav_four">
      <div class="wrap">
        <div class="global_top_nav_four_menu">
          <div class="globalFourMenus">
            <a @click="pushOld('')"
               href="javascript:void(0);">首页</a>
          </div>
          <div class="globalFourMenus">
            <a @click="pushOld('tourism/tourism_product.jsp?part_enname=chujingyou&init=1&ordinary_search=1')"
               href="javascript:void(0);">出境游</a>
            <!-- 二级导航 -->
            <div class="globalFourMenu_box globalFourMenu_box1">
              <div class="wrap">
                <div class="nav_left fl">
                  <div :key="index"
                       class="innerNav"
                       v-for="(leftInfo,index) in left_subpartlist">
                    <h1>
                      <a @click="pushOld('tourism/tourism_product.jsp?init=1&part_enname=' + leftInfo.part_enname)"
                         href="javascript:void(0);">{{leftInfo.part_name}}</a>
                    </h1>

                    <div class="innerNav_a"
                         v-if="leftInfo.part_enname">
                      <a :key="index"
                         @click="pushOld('tourism/tourism_product.jsp?init=1&part_enname=' + one.part_enname)"
                         href="javascript:void(0);"
                         v-for="(one,index) in chujingyou_list[leftInfo.part_enname]">{{one.part_name}}</a>
                      <div class="clear"></div>
                    </div>
                  </div>
                </div>
                <div class="nav_right fr">
                  <div :key="index"
                       class="innerNav"
                       v-for="(rightInfo,index) in right_subpartlist">
                    <h1>
                      <a @click="pushOld('tourism/tourism_product.jsp?init=1&part_enname=' + rightInfo.part_enname)"
                         href="javascript:void(0);">{{rightInfo.part_name}}</a>
                    </h1>
                    <div class="innerNav_a"
                         v-if="rightInfo.part_enname">
                      <a :key="index"
                         @click="pushOld('tourism/tourism_product.jsp?init=1&part_enname=' + one.part_enname)"
                         href="javascript:void(0);"
                         v-for="(one,index) in chujingyou_list[rightInfo.part_enname]">{{one.part_name}}</a>
                      <div class="clear"></div>
                    </div>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <!-- 二级导航结束 -->
          </div>
          <div class="globalFourMenus">
            <a @click="pushOld('tourism/tourism_product.jsp?part_enname=guoneiyou&init=1&ordinary_search=1')"
               href="javascript:void(0);">国内游</a>
            <!-- 二级导航 -->
            <div class="globalFourMenu_box globalFourMenu_box2">
              <div class="wrap">
                <div class="innerNav">
                  <div class="innerNav_a"
                       v-if="guoneiyou">
                    <div v-for="(guonei,index) in this.guoneiyou">
                      <a @click="pushOld('tourism/tourism_product.jsp?init=1&part_enname=' + guonei.part_enname)"
                         href="javascript:void(0);"
                         title>{{guonei.part_name}}</a>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 二级导航结束 -->
          </div>
          <div class="globalFourMenus">
            <a @click="pushOld('tourism/tourism_product.jsp?part_enname=shengneiyou&init=1&ordinary_search=1')"
               href="javascript:void(0);">省内游</a>
            <!-- 二级导航 -->
            <div class="globalFourMenu_box globalFourMenu_box3">
              <div class="wrap">
                <div class="innerNav">
                  <div class="innerNav_a"
                       v-if="shengneiyou">
                    <div v-for="(shengnei,index) in this.shengneiyou">
                      <a @click="pushOld('tourism/tourism_product.jsp?init=1&part_enname=' + shengnei.part_enname)"
                         href="javascript:void(0);"
                         title>{{shengnei.part_name}}</a>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 二级导航结束 -->
          </div>
          <div class="globalFourMenus">
            <a @click="pushOld('tourism/tourism_product.jsp?part_enname=youlun&init=1&ordinary_search=1')"
               href="javascript:void(0);">邮 轮</a>
            <!-- 二级导航 -->
            <div class="globalFourMenu_box globalFourMenu_box4">
              <div class="wrap">
                <div class="innerNav">
                  <div class="innerNav_a"
                       v-if="youlun">
                    <div v-for="(ship,index) in this.youlun">
                      <a @click="pushOld('tourism/tourism_product.jsp?init=1&part_enname=' + ship.part_enname)"
                         href="javascript:void(0);"
                         title>{{ship.part_name}}</a>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 二级导航结束 -->
          </div>
          <div class="globalFourMenus">
            <a @click="pushOld('tourism/tourism_product.jsp?part_enname=taiwanyou&init=1&ordinary_search=1')"
               href="javascript:void(0);">台湾游</a>
            <!-- 二级导航 -->
            <div class="globalFourMenu_box globalFourMenu_box7">
              <div class="wrap">
                <div class="innerNav">
                  <div class="innerNav_a"
                       v-if="taiwanyou">
                    <div v-for="(taiwan,index) in this.taiwanyou">
                      <a @click="pushOld('tourism/tourism_product.jsp?init=1&part_enname=' + taiwan.part_enname)"
                         href="javascript:void(0);"
                         title>{{taiwan.part_name}}</a>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 二级导航结束 -->
          </div>
          <div class="globalFourMenus">
            <a @click="pushOld('tourism/tourism_product.jsp?part_enname=gangaoyou&init=1&ordinary_search=1')"
               href="javascript:void(0);">港澳游</a>
            <!-- 二级导航 -->
            <div class="globalFourMenu_box globalFourMenu_box5">
              <div class="wrap">
                <div class="innerNav">
                  <div class="innerNav_a"
                       v-if="gangaoyou">
                    <div v-for="(gangao,index) in this.gangaoyou">
                      <a @click="pushOld('tourism/tourism_product.jsp?init=1&part_enname=' + gangao.part_enname)"
                         href="javascript:void(0);"
                         title>{{gangao.part_name}}</a>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 二级导航结束 -->
          </div>
          <div class="globalFourMenus">
            <a @click="pushOld('tourism/tourism_product.jsp?part_enname=haidao&init=1&ordinary_search=1')"
               href="javascript:void(0);">海 岛</a>
            <!-- 二级导航 -->
            <div class="globalFourMenu_box globalFourMenu_box8">
              <div class="wrap">
                <div class="innerNav">
                  <div class="innerNav_a"
                       v-if="haidao">
                    <!-- <jsp:include page="/inc/product_webpart_inc.jsp?parent=haidao"
                    flush="true"></jsp:include>-->
                    <div v-for="(place,index) in this.haidao">
                      <a @click="pushOld('tourism/tourism_product.jsp?init=1&part_enname=' + place.part_enname)"
                         href="javascript:void(0);"
                         title>{{place.part_name}}</a>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 二级导航结束 -->
          </div>
          <div class="globalFourMenus">
            <a @click="visaPage()"
               href="javascript:void(0);">签 证</a>
            <!-- 二级导航 -->
            <div class="globalFourMenu_box globalFourMenu_box8">
              <div class="wrap">
                <div class="innerNav">
                  <div class="innerNav_a"
                       v-if="visaNationsInfo">
                    <div v-for="(place,index) in this.visaNationsInfo">
                      <a @click="visaCountryPage(place)"
                         href="javascript:void(0);"
                         title>{{place}}</a>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 二级导航结束 -->
          </div>
          <div class="globalFourMenus">
            <a @click="pushOld('tourism/travel_cards.jsp')"
               href="javascript:void(0);">旅游卡</a>
          </div>
          <div class="globalFourMenus">
            <a @click="pushOld('tourism/about_us.jsp')"
               href="javascript:void(0);">关于我们</a>
            <!-- 二级导航 -->
            <div class="globalFourMenu_box globalFourMenu_box6">
              <div class="wrap">
                <div class="innerNav">
                  <div class="innerNav_a">
                    <a href="/tourism/about_us.jsp"
                       target="_blank">华侨城旅行社介绍</a>
                    <a href="/tourism/about_us.jsp#web02"
                       target="_blank">历年获奖</a>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 二级导航结束 -->
          </div>
          <div class="globalFourMenus"
               style="float:right"
               v-if="$sessionStorageUtil.get('web_type') != 2 && $loginType() != 0">
            <a @click="pushOld('tourism/network.jsp')"
               href="javascript:void(0);">身边的网点</a>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!-- 导航结束 -->
  </div>
</template>
<script>
import HeaderLogin from '@/pages/components/headerLogin.vue'
export default {
  components: {
    HeaderLogin
  },
  data () {
    return {
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）,
      time: false,
      days: false,
      number: 0,
      departure: '出发时间',
      trip: '行程天数',
      img_logo_pc: '',
      img_search_bg: '',
      visaNationsInfo: '',
      get_sub_part_list_url: 'webpart/sub_part_list_info',
      route_url: '/webpart/head_data',
      route_url_param: {
        logoPc: 'logo_pc',
        searchBgImg: 'search_bg_img',
        hotPlace: 'hotsearch',
        chujingyou: 'chujingyou',
        othertravel:
          [
            'guoneiyou',
            'shengneiyou',
            'youlun',
            'taiwanyou',
            'gangaoyou',
            'haidao'
          ] + ''
      },
      csubpart_list_info: {},
      left_subpartlist: [],
      right_subpartlist: [],
      labels: [],
      chujingyou: [],
      guoneiyou: [],
      shengneiyou: [],
      youlun: [],
      taiwanyou: [],
      gangaoyou: [],
      haidao: [],
      chujingyou_list: {},
      search_param: {
        route_name: '',
        id1_order_by1: '',
        id1_order_by2: ''
      }
    }
  },
  created () {
    this.$myGet(this.route_url, this.route_url_param)
      .then(res => {
        this.labels = res.response.data.customcolumns.part_content
          .replace('&nbsp;|\\s', '')
          .replace(/<\/?[^>]*>/g, '')
          .split(',')
        this.chujingyou = res.response.data.csubpartlist
        this.getChujingyouListInfo()
        this.isInit = false
        this.img_logo_pc = res.response.data.logoPcUrl
        this.img_search_bg = res.response.data.searchBgImgUrl
        this.visaNationsInfo = res.response.data.visaNationsInfo
        this.guoneiyou = res.response.data.subpartlistinfos.guoneiyou
        this.gangaoyou = res.response.data.subpartlistinfos.gangaoyou
        this.shengneiyou = res.response.data.subpartlistinfos.shengneiyou
        this.taiwanyou = res.response.data.subpartlistinfos.taiwanyou
        this.haidao = res.response.data.subpartlistinfos.haidao
        this.youlun = res.response.data.subpartlistinfos.youlun
      })
      .catch(err => {
        this.$msg('[' + err.status + ']' + err.message)
      })
  },
  computed: {
    isShowLogin () {
      return this.$store.state.showLoginBar
    }
  },
  methods: {
    pushOld (url) {
      window.location.href = this.$getOldWebUrl() + url
    },
    visaPage () {
      this.$sessionStorageUtil.remove('relative_city')
      location.reload()
      this.$pushByName('visaProduct')
    },
    visaCountryPage (country) {
      this.$sessionStorageUtil.remove('relative_city')
      this.$sessionStorageUtil.set('relative_city', country)
      location.reload()
      this.$pushByName('visaProduct')
    },
    timeEnter: function () {
      return (this.time = true)
    },
    timeLeave: function () {
      return (this.time = false)
    },
    daySenter: function () {
      return (this.days = true)
    },
    daysLeave: function () {
      return (this.days = false)
    },
    herfSubPartList: function () {
      var totalLength = this.chujingyou.length
      var count = 0
      for (var i = 0; i < this.chujingyou.length; i++) {
        if (this.chujingyou[i].part_enname) {
          totalLength += this.chujingyou_list[this.chujingyou[i].part_enname]
            .length
        }
      }
      for (var j = 0; j < this.chujingyou.length; j++) {
        count++
        if (count < totalLength / 2) {
          this.left_subpartlist.push(this.chujingyou[j])
          if (this.chujingyou[j].part_enname) {
            count += this.chujingyou_list[this.chujingyou[j].part_enname].length
          }
        } else {
          this.right_subpartlist.push(this.chujingyou[j])
          if (this.chujingyou[j].part_enname) {
            count += this.chujingyou_list[this.chujingyou[j].part_enname].length
          }
        }
      }
    },
    orderBy (departure) {
      if (!this.search_param.route_name) {
        this.$messageBox.alert('请输入内容！')
        return
      }
      if (departure == '最近的出发时间') {
        this.search_param.id1_order_by1 = 'depart_time asc'
      } else if (departure == '最远的出发时间') {
        this.search_param.id1_order_by1 = 'depart_time desc'
      } else if (departure == '最少行程的天数') {
        this.search_param.id1_order_by2 = 'route_days asc'
      } else if (departure == '最多行程的天数') {
        this.search_param.id1_order_by2 = 'route_days desc'
      }
      this.searchSubmit()
    },
    searchSubmit () {
      this.$refs.ordinary_search.click()
    },
    getChujingyouListInfo: function () {
      const part_ennames = []
      for (let i = 0; i < this.chujingyou.length; i++) {
        part_ennames[i] = this.chujingyou[i].part_enname
      }
      this.$myGet(this.get_sub_part_list_url, {
        partEnnames: part_ennames + ''
      })
        .then(res => {
          this.chujingyou_list = res.response.data.subpartlistinfos
          this.herfSubPartList()
        })
        .catch(err => {
          this.$msg('[' + err.status + ']' + err.message)
        })
    }
  },
   mounted () {
  },
}
</script>
<style>
@import '../../assets/css/pages/html/header.css';
</style>



// WEBPACK FOOTER //
// src/pages/components/commonHeaderFrame.vue